var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcInfoI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6C11 7.32608 10.4732 8.59785 9.53553 9.53553C8.59785 10.4732 7.32608 11 6 11C4.67392 11 3.40215 10.4732 2.46447 9.53553C1.52678 8.59785 1 7.32608 1 6C1 4.67392 1.52678 3.40215 2.46447 2.46447C3.40215 1.52678 4.67392 1 6 1C7.32608 1 8.59785 1.52678 9.53553 2.46447C10.4732 3.40215 11 4.67392 11 6ZM5.5 6.5V8C5.5 8.13261 5.55268 8.25979 5.64645 8.35355C5.74021 8.44732 5.86739 8.5 6 8.5C6.13261 8.5 6.25979 8.44732 6.35355 8.35355C6.44732 8.25979 6.5 8.13261 6.5 8V6.5C6.5 6.36739 6.44732 6.24021 6.35355 6.14645C6.25979 6.05268 6.13261 6 6 6C5.86739 6 5.74021 6.05268 5.64645 6.14645C5.55268 6.24021 5.5 6.36739 5.5 6.5ZM6 3.75C5.80109 3.75 5.61032 3.82902 5.46967 3.96967C5.32902 4.11032 5.25 4.30109 5.25 4.5C5.25 4.69891 5.32902 4.88968 5.46967 5.03033C5.61032 5.17098 5.80109 5.25 6 5.25C6.19891 5.25 6.38968 5.17098 6.53033 5.03033C6.67098 4.88968 6.75 4.69891 6.75 4.5C6.75 4.30109 6.67098 4.11032 6.53033 3.96967C6.38968 3.82902 6.19891 3.75 6 3.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfoI);
export default __webpack_public_path__ + "static/media/ic_info_i.62aa488d34b6bfcf0013a4f89c86a321.svg";
export { ForwardRef as ReactComponent };